import tippy from 'tippy.js'

export default class GalleryTooltip {
    constructor(el) {
        let tooltipjson = JSON.parse($('.c-advanced-gallery').attr('data-tooltip-options')); // JSON
        let button = $(el).find('.c-advanced-gallery__hotspot-icon')[0];
        let templateid = $(el).attr('data-template');
        let template = document.getElementById(templateid);

        tippy(button, {
            content: template.innerHTML,
            allowHTML: true,
            interactive: true,
            interactiveBorder: tooltipjson.interactive_border,
            placement: tooltipjson.placement,
            inertia: true,
            arrow: true,
            duration: [tooltipjson.duration_in, tooltipjson.duration_out],
            trigger: 'mouseenter click',
        });
    }
}